var FacebookPageDataBuilder = /** @class */ (function () {
    function FacebookPageDataBuilder() {
        this.facebookPageData = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            token: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            picture: 'https://graph.facebook.com/v2.5/b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b/picture',
            category: 'bob',
            wallPostEnabled: true,
            privateMessageEnabled: true,
        };
    }
    FacebookPageDataBuilder.prototype.withId = function (id) {
        this.facebookPageData.id = id;
        return this;
    };
    FacebookPageDataBuilder.prototype.withToken = function (token) {
        this.facebookPageData.token = token;
        return this;
    };
    FacebookPageDataBuilder.prototype.withPicture = function (picture) {
        this.facebookPageData.picture = picture;
        return this;
    };
    FacebookPageDataBuilder.prototype.withCategory = function (category) {
        this.facebookPageData.category = category;
        return this;
    };
    FacebookPageDataBuilder.prototype.withWallPostEnabled = function (wallPostEnabled) {
        this.facebookPageData.wallPostEnabled = wallPostEnabled;
        return this;
    };
    FacebookPageDataBuilder.prototype.withWallPostPrivateMessageEnabled = function (privateMessageEnabled) {
        this.facebookPageData.privateMessageEnabled = privateMessageEnabled;
        return this;
    };
    FacebookPageDataBuilder.prototype.build = function () {
        return this.facebookPageData;
    };
    return FacebookPageDataBuilder;
}());
export { FacebookPageDataBuilder };
;
//# sourceMappingURL=facebook-page-data-builder.js.map